import React from 'react';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { showDatasetConditions } from '@/datasets/conditions/actions';
import CohortStatusButtons from '../components/CohortStatusButtons';
import cohortStatus from '../helper';

const CohortStatusCell = ({
  accessRequestAllowed,
  accessRequestSupported,
  accessRequestUnsupportedReasons,
  cohort,
  hasConditions,
  showConditions,
  newRequestCode,
}) => (
  <Table.Cell className="aridhia-cohort-status-cell">
    <CohortStatusButtons
      accessRequestAllowed={accessRequestAllowed}
      accessRequestSupported={accessRequestSupported}
      accessRequestUnsupportedReasons={accessRequestUnsupportedReasons}
      code={cohort.code}
      hasConditions={hasConditions}
      icon
      name={cohort.name}
      newRequestCode={newRequestCode}
      showConditions={showConditions}
      workflowKey={cohort.settings.workflow_key}
    />
  </Table.Cell>
);

const mapStateToProps = ({
  auth: { role },
  requests: { newRequestCode },
}, { cohort }) => ({
  newRequestCode,
  ...cohortStatus(role, cohort),
});

const mapDispatchToProps = {
  showConditions: showDatasetConditions,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortStatusCell);
